import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";

export const ImageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ImageContentClickable = styled(Button)`
  padding: 0;
  display: block;
`;
